export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_5.1-98aab93b1383eccea14ac55ad5d30e57.svg";